<input
  #autoInput
  nbInput
  type="text"
  (input)="onChange()"
  fullWidth
  placeholder="لیست بازارها"
  [nbAutocomplete]="auto"
/>

<nb-autocomplete #auto (selectedChange)="onSelectionChange($event)">
  <nb-option *ngFor="let market of filteredMarkets" [value]="market">
    <div class="d-flex justify-content-center align-items-center">
      <img class="ms-2" width="20" height="20" [src]="market.baseCurrency.iconPath" />
      <span>{{ market.baseCurrency.name }} - {{ market.quoteCurrency.name }}</span>
    </div>
  </nb-option>
</nb-autocomplete>
